import { useEffect } from "react";
import { createPortal } from "react-dom";

// Ventana modal accesible: se cierra con Escape, con el botón de cerrar o al hacer clic
// afuera. Si es más alta que la pantalla se desplaza la ventana, no la página de atrás.
// Se dibuja en <body>: dentro de un panel con desenfoque (backdrop-filter) o animación, "fixed"
// quedaría atado a ese panel y la ventana saldría corrida y cortada.
function Modal({ titulo, onCerrar, children, ancho = "max-w-md" }) {
  useEffect(() => {
    const alPresionar = (e) => e.key === "Escape" && onCerrar();
    window.addEventListener("keydown", alPresionar);
    return () => window.removeEventListener("keydown", alPresionar);
  }, [onCerrar]);

  useEffect(() => {
    const anterior = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = anterior; };
  }, []);

  const cerrarAfuera = (e) => e.target === e.currentTarget && onCerrar();

  return createPortal(
    <div
      className="ventana-fondo fixed inset-0 z-50 overflow-y-auto overscroll-contain bg-black/80 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-label={titulo}
      onMouseDown={cerrarAfuera}
    >
      <div className="flex min-h-full items-center justify-center p-4 sm:p-8" onMouseDown={cerrarAfuera}>
        <div className={`ventana-panel w-full ${ancho} rounded-2xl border border-white/10 bg-zinc-950 p-6 sm:p-8`}>
          <div className="mb-6 flex items-start justify-between gap-4">
            <h3 className="titulo-ventana">{titulo}</h3>
            <button onClick={onCerrar} aria-label="Cerrar" className="text-2xl leading-none text-gray-500 transition hover:text-white">
              ×
            </button>
          </div>
          {children}
        </div>
      </div>
    </div>,
    document.body,
  );
}

export default Modal;
